import _ from 'lodash'

import partServer from '../../../../server/index'
import template from './index.html'
import repeatController from '../../../../../ui-formly/types/repeater/controller'

import { vsName as ServerUtilityName } from '../../../../../records/server/serverUtility'

formlyLocations.$inject = []
function formlyLocations() {
  var formly = {
    key: 'Locations',
    name: 'Locations',
    data: {
      totalQuantity: 0,
      onModelChange: modelChange
    },
    controller: repeatController,
    templateUrl: template,
    templateOptions: {
      addText: 'Add Location',
      fields: [
        {
          key: "PropertyId",
          name: "PropertyId",
          type: "gridSelectAsync",
          templateOptions: {
            label: "Property",
            required: true,
            showAddButton: false,
            query: [ServerUtilityName, function (serverUtility) {
              return function (search) {
                return serverUtility.lookupQuery({
                  url: "/api/properties",
                  search
                })
              }
            }],
            updateNameProp: 'PropertyName',
            getDefaultItem: function (model) {
              if (!model.Property) {
                return {}
              }
              return model.Property
            }
          },
          className: 'col-xs-3',
          controller: ['$scope', ServerUtilityName, function ($scope, serverUtility) {
            serverUtility.fetchAll({
              url: "/api/properties",
              query: {OrderBy : "Name"}
            }).then(properties => {
              $scope.properties = properties
              const model = $scope.model
              const partProperty = model.PartProperty
              const { updateNameProp } = $scope.to
              let property

              if (partProperty) {
                const currentPropertyId = partProperty.PropertyId
                property = properties.find(p => p.Id === currentPropertyId)
              } else if (properties.length === 1) {
                property = properties[0]
              }

              if (updateNameProp && property) {
                $scope.model[updateNameProp] = property.Name
                $scope.model.PropertyId = property.Id
              }
            })
          }],
          expressionProperties: {
            'templateOptions.disabled': 'properties.length === 1'
          }
        },
        {
          key: 'PartPropertyId',
          name: 'PartPropertyId',
          type: 'gridSelectAsync',
          templateOptions: {
            required: true,
            label: 'Room',
            query: [partServer.vsName, '$scope', '$q', function (partServer, $scope, $q) {
              return function (search) {
                let propertyId = $scope.model.PropertyId

                if (!propertyId) {
                  return $q.when([])
                }

                return partServer.partPropertyQuery({
                  NameContains: search,
                  PropertyId: propertyId,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Name'
                })
              }
            }],
            showAddButton: false,
            getDefaultItem: function (model) {
              if (!model.PartProperty) {
                return {}
              }
              return model.PartProperty
            }
          },
          className: 'col-xs-3',
          watcher: [{
            expression: 'model.PropertyId',
            listener: (field, newValue, oldValue, scope) => {
              if (oldValue !== newValue) {
                const partProperty = scope.model.PartProperty
                if (!(partProperty && partProperty.PropertyId === newValue)) {
                  scope.model[field.key] = undefined
                }
              }
            }
          }],
          expressionProperties: {
            'templateOptions.disabled': '!model.PropertyId'
          }
        },
        {
          key: 'Shelf',
          name: 'Shelf',
          type: 'gridInput',
          templateOptions: {
            required: true,
            label: 'Shelf'
          },
          className: 'col-xs-2'
        },
        {
          key: 'Bin',
          name: 'Bin',
          type: 'gridInput',
          templateOptions: {
            required: true,
            label: 'Bin'
          },
          className: 'col-xs-2'
        },
        {
          key: 'Quantity',
          name: 'Quantity',
          type: 'gridInput',
          modelOptions: {
            debounce: {
              'default': 500,
              'blur': 0
            }
          },
          templateOptions: {
            required: true,
            label: 'Quantity',
            type: 'number',
            min: 0
          },
          className: 'col-xs-1'
        }
      ]
    }
  }

  return [formly]
}

function modelChange(newLocations, oldLocations, $scope) {
  var totalQuantity = getTotalQuantity(newLocations)
  $scope.options.data.totalQuantity = totalQuantity
}

function getTotalQuantity(locations) {
  var count = locations ? locations.length : 0
  if (count > 0) {
    var totalQuantity = _.reduce(locations, function (sum, location) { return sum + location.Quantity }, 0)
    return totalQuantity
  }

  return 0
}

export default formlyLocations
